<!-- <div id="cover-spin" ></div> -->
<div class="loaderIcon" *ngIf="!isPaymentRefund && !dlScanloaderRequest">
    <img src="../../../assets/images/LoaderGif.gif" alt="Loader">
</div>

<div class="loaderIcon"
    *ngIf="isPaymentRefund || isReversal || isEmvAutopay || isManualAutopay || userRiskDelay || dlScanloaderRequest || isReportGeneration">
    <figure>
        <img src="../../../assets/images/LoaderGif.gif" alt="Loader">
        <figcaption
            *ngIf="(isPaymentRefund && showPaymentMessage && !initiatedVoidCC) || (isManualAutopay && !processingUnit)"
            class="initiatedvoid">Transaction is in Progress. Please do not leave the page!</figcaption>
        <figcaption align="center" *ngIf="isManualAutopay && processingUnit" class="initiatedvoid">Transaction is in
            Progress. Please do not leave the page!<br> Processing payment for Unit #: {{processingUnit}}</figcaption>
        <figcaption *ngIf="initiatedVoidCC" class="initiatedvoid emvinitiatedvoid">Please check EMV Terminal Device!
        </figcaption>
        <figcaption *ngIf="retryTransactionStatus" class="emvtransactionRetry">Payment is Not completed in the Terminal
            Device. Please complete before transaction is cancelled!</figcaption>
        <figcaption *ngIf="userRiskDelay" class="initiatedvoid userRiskDelay">The Changes will be reflected in some
            time. Please verify after sometime!</figcaption>
        <figcaption *ngIf="dlScanloaderRequest" class="initiatedvoid">DL Scanning is in Progress. Please wait for few
            seconds</figcaption>
        <figcaption *ngIf="isReportGeneration" class="initiatedvoid">Report is getting Generated. Please do not leave
            the page!</figcaption>
        <figcaption *ngIf="isTDEmv?.isTransactionWaitTime" class="initiatedvoid" style="left: 52%;">Please complete the
            transaction before - {{display}}</figcaption>
        <figcaption *ngIf="isTDEmv?.isPortClosingWaitTime" class="initiatedvoid emvinitiatedvoid" style="left: 48.5%;">
            Please wait until the port is closed - {{display}}</figcaption>
        <figcaption *ngIf="isTDEmv?.isVoidTransactionWaitTime" class="emvtransactionRetry"
            style="left: 46% !important;">Please Check EMV Terminal Device and Wait While Your Transaction is Processing
            - {{display}} </figcaption>
        <div class="button-container" [ngClass]="{'button-padding': isTDEmv?.isVoidTransactionWaitTime}" [ngStyle] = "{'margin-left': initiatedStripEMVPayment ? '3rem' : 'none'}"
            *ngIf="stripeLoader?.isStripeterminal">
            <button type="button" class="btn btn-primary statusButton" (click)="onStatusClick()">Status</button>
            <button type="button" class="cancelButton" (click)="onCancelClick()"
                [disabled]="isCancelledDisabled">Cancel</button>
        </div>
        <figcaption *ngIf="initiatedStripEMVPayment" class="initiatedvoid emvinitiatedvoid">Please check EMV Terminal Device! - {{display}}</figcaption>
    </figure>
</div>
